module.exports = __webpack_public_path__ + "img/c2p-logo-black.svg";